import React, { useState } from "react";
import { Box } from "@mui/material";
import { tokens } from "../../../../theme";
import { useTheme } from "@mui/material/styles";
import { bulkuseruploadData } from "../../../../services/apiService";
import Topbar from "../../../../scenes/global/Topbar";

const GyanniBulkUserUpload = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validTypes.includes(selectedFile.type)) {
        alert("Please upload a valid Excel file (.xls or .xlsx)");
        e.target.value = "";
        setFile(null);
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("myFile", file);
    try {
      const response = await bulkuseruploadData(formData);
      alert("File uploaded successfully!");
      setFile(null);
      window.location.reload();
    } catch (error) {
      alert("Failed to upload file.");
    }
  };

  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>

      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <form>
            <div className="flex justify-center">
              <div className="w-full max-w-2xl space-y-12">
                <div className="border-b border-gray-900/10">
                  <h2 className="text-center text-xl font-semibold text-gray-900 mt-4">
                    Bulk User Upload
                  </h2>
                  <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8">
                    <div className="col-span-full">
                      <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                        <div className="text-center">
                          <div className="mt-4 flex items-center justify-center text-sm text-gray-600">
                            <label
                              htmlFor="file-upload"
                              className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                            >
                              <span>Upload a file</span>
                              <input
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                accept=".xlsx, .xls"
                                className="sr-only"
                                onChange={handleFileChange}
                              />
                            </label>
                            <p className="pl-2">or drag and drop</p>
                          </div>

                          {file && (
                            <p className="mt-2 text-sm text-green-700">
                              Selected file :{" "}
                              <span className="font-medium">{file.name}</span>
                            </p>
                          )}
                          <p className="text-xs text-gray-600">
                            Only Excel format is allowed.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center items-center">
                  <button
                    type="submit"
                    onClick={handleUpload}
                    className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default GyanniBulkUserUpload;
